import { render, staticRenderFns } from "./FieldAgencyType.vue?vue&type=template&id=6267eda4&"
import script from "./FieldAgencyType.vue?vue&type=script&lang=js&"
export * from "./FieldAgencyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports